import './AdminSidebar.css'; // Import the corresponding CSS file
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../services/redux/authSlice';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import logo from '../../../assets/images/logo_navbar_white.png';
import DashBoardIcon from '../../icons/DashBoardIcon';
import LogoffIcon from '../../icons/LogoffIcon';
import { useLocation } from 'react-router-dom';
import LogIcon from '../../icons/LogIcon';
import IntegrationIcon from '../../icons/IntegrationIcon';
import CityIcon from '../../icons/CityIcon';
import UsersIcon from '../../icons/UsersIcon';
import OrderIcon from '../../icons/OrderIcon';
import MailIcon from '../../icons/MailIcon';
import SettingsIcon from '../../icons/SettingsIcon';

const AdminSidebar = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  
  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
    toast.success("Até breve!");
  };

  return (
    <aside className="sidebar">
      <div className="sidebar__logo">
        <img src={logo} alt="Logo" />
      </div>
      <nav className="sidebar__menu">
        {isAdmin && <a href="/" className={pathSegments.length === 0 || (pathSegments[0] === 'dashboard') || pathSegments[1] === 'dashboard' ? "sidebar__menu-item sidebar__menu-item-selected" : "sidebar__menu-item"}><DashBoardIcon color='white'/>Dashboard</a>}
        {isAdmin && <a href="/pedidos" className={pathSegments[0] === 'pedidos' ? "sidebar__menu-item sidebar__menu-item-selected" : "sidebar__menu-item"}><OrderIcon color='white'/>Pedidos</a>}
        {isAdmin && <a href="/usuarios" className={pathSegments[0] === 'usuarios' ? "sidebar__menu-item sidebar__menu-item-selected" : "sidebar__menu-item"}><UsersIcon color='white'/>Usuários</a>}
        {isAdmin && <a href="/emails" className={pathSegments[0] === 'emails' ? "sidebar__menu-item sidebar__menu-item-selected" : "sidebar__menu-item"}><MailIcon color='white'/>Emails Enviados</a>}
        {isAdmin && <a href="/cidades" className={pathSegments[0] === 'cidades' ? "sidebar__menu-item sidebar__menu-item-selected" : "sidebar__menu-item"}><CityIcon color='white'/>Cidades</a>}
        {isAdmin && <a href="/logs" className={pathSegments[0] === 'logs' ? "sidebar__menu-item sidebar__menu-item-selected" : "sidebar__menu-item"}><LogIcon color='white'/>Logs</a>}
        {isAdmin && <a href="/logs-integration" className={pathSegments[0] === 'logs-integration' ? "sidebar__menu-item sidebar__menu-item-selected" : "sidebar__menu-item"}><IntegrationIcon color='white'/>Integrações</a>}
        {isAdmin && <a href="/configuracoes" className={pathSegments[0] === 'configuracoes' ? "sidebar__menu-item sidebar__menu-item-selected" : "sidebar__menu-item"}><SettingsIcon color='white'/>Configurações</a>}
        </nav>
      <button className="sidebar__logoff" onClick={handleLogout}>
        Sair <LogoffIcon color='white'/>
      </button>
    </aside>
  );
};

export default AdminSidebar;
